<div
  class="min-h-screen bg-gradient-to-br from-[#2c5f8d] to-[#4A90E2] flex items-center justify-center p-4"
>
  <div class="w-full max-w-md">
    <!-- Success Message -->
    <div *ngIf="successMessage">
      <div class="bg-white rounded-lg shadow-xl p-8">
        <div class="text-center">
          <div
            class="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"
          >
            <svg
              class="w-10 h-10 sm:w-12 sm:h-12 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
            Senha Alterada com Sucesso!
          </h2>
          <p class="text-sm sm:text-base text-gray-600 mb-4">
            Você será redirecionado automaticamente...
          </p>
          <div
            class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4A90E2] mx-auto"
          ></div>
        </div>
      </div>
    </div>

    <!-- Form -->
    <div *ngIf="!successMessage">
      <!-- Logo -->
      <div class="text-center mb-8">
        <img
          src="https://zoomeduca.com.br/logo.svg"
          alt="Zoom Educa"
          class="w-32 mb-3 h-auto mx-auto brightness-0 invert drop-shadow-lg"
        />
        <h1 class="text-3xl font-bold text-white mb-2">Nova Senha</h1>
        <p class="text-white/90">Digite sua nova senha</p>
      </div>

      <!-- Card -->
      <div class="bg-white rounded-lg shadow-xl p-8">
        <form (ngSubmit)="onSubmit()" #resetForm="ngForm">
          <div class="space-y-6">
            <!-- New Password -->
            <div>
              <label class="block text-sm font-medium text-gray-900 mb-1">
                Nova Senha *
              </label>
              <div class="relative">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  [(ngModel)]="newPassword"
                  name="newPassword"
                  #newPasswordInput="ngModel"
                  required
                  minlength="6"
                  placeholder="Mínimo 6 caracteres"
                  class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent"
                  [class.border-red-500]="submitted && newPasswordInput.invalid"
                />
                <button
                  type="button"
                  (click)="togglePassword()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  <svg
                    *ngIf="!showPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="showPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </button>
              </div>
              <p
                *ngIf="submitted && newPasswordInput.invalid"
                class="mt-1 text-sm text-red-600"
              >
                {{ newPasswordInput.errors?.['required'] ? 'Senha é obrigatória' : 'Senha deve ter no mínimo 6 caracteres' }}
              </p>
            </div>

            <!-- Confirm Password -->
            <div>
              <label class="block text-sm font-medium text-gray-900 mb-1">
                Confirmar Senha *
              </label>
              <div class="relative">
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  [(ngModel)]="confirmPassword"
                  name="confirmPassword"
                  #confirmPasswordInput="ngModel"
                  required
                  placeholder="Confirme sua senha"
                  class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent"
                  [class.border-red-500]="
                    submitted &&
                    (confirmPasswordInput.invalid ||
                      newPassword !== confirmPassword)
                  "
                />
                <button
                  type="button"
                  (click)="toggleConfirmPassword()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  <svg
                    *ngIf="!showConfirmPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="showConfirmPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </button>
              </div>
              <p
                *ngIf="
                  submitted &&
                  newPassword &&
                  confirmPassword &&
                  newPassword !== confirmPassword
                "
                class="mt-1 text-sm text-red-600"
              >
                As senhas não coincidem
              </p>
            </div>

            <!-- Submit Button -->
            <button
              app-button
              type="submit"
              variant="success"
              [loading]="isLoading"
              loadingText="Redefinindo..."
              class="py-3"
            >
              Redefinir Senha
            </button>

            <!-- Back to Login -->
            <button
              app-button
              variant="ghost"
              routerLink="/login"
              className="text-sm text-gray-600 hover:text-[#4A90E2] font-medium"
            >
              Voltar para o login
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
